/* Mobile smartBanner define */
(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('footer.smartBanner', ['jquery'],
      function load(jQuery) {
        return factory(root, jQuery);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.smartBanner = factory(root, jQuery);
    /*eslint-enable*/
  }
})(this, function factory(root, $) {
  var module = {};
  var privateMethods = {};
  privateMethods.fallbackLink = '';
  // Private Methods
  privateMethods.gotoStore = function gotoStore() { // redirect call to AppStore/PlayStore
    var _this = this,
      $bannerIFrame = $('#smartBannerIFrame');

    if ($bannerIFrame.length) {
      $bannerIFrame.remove();
    }
    $('<iframe />')
      .attr('id', 'smartBannerIFrame')
      .attr('src', 'homedepot://homedepot.com')
      .attr('style', 'display:none;')
      .appendTo('body');

    _this.timeout = setTimeout(function() {
      window.location = privateMethods.fallbackLink;
    }, 25);
    window.addEventListener('pagehide', privateMethods.preventPopup);
  };
  privateMethods.preventPopup = function preventPopup() { // cancel popup native browser alert
    var _this = this;
    clearTimeout(_this.timeout);
    _this.timeout = null;
    window.removeEventListener('pagehide', _this.preventPopup);
  };

  privateMethods.getUserAgent = function() {
    return navigator.userAgent;
  };

  module.init = function initSmartBanner() {
    var $el = $('#smartBannerURL');
    //use thdUtils.phoneAgent();
    var navusr = privateMethods.getUserAgent();
    var isiOS = navusr.match('iPad') || navusr.match('iPhone') || navusr.match('iPod'),
      isAndroid = navusr.match('Android');
    privateMethods.fallbackLink = isAndroid ? 'market://details?id=com.thehomedepot' : 'itms-apps://itunes.apple.com/app/my-app/id342527639?mt=8';
    this.timeout = null;
    this.$el = $el;
    var _this = this;
    // Show smartBanner DIV for iOS & Android devices only
    if (isiOS || isAndroid) {
      this.$el.removeClass('hide').addClass('show');
      _this.$el.on('click', function(e) {
        e.preventDefault();
        privateMethods.gotoStore();
      });
    }
  };

  module.getPrivateMethods = function() {
    return privateMethods;
  }

  return module;
});
